<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['unhide']);
</script>

<template>
  <DefaultButton
    variant="primary-inverted"
    size="small"
    class="tw-flex tw-items-center tw-gap-2 tw-text-base!"
    @click="emit('unhide')"
  >
    <svg-vue
      icon="icons/eye-hidden"
      class="tw-h-5 tw-w-5"
    />
    <span>Unhide All</span>
  </DefaultButton>
</template>
